export default "__VITE_ASSET__2fqshdYH__"